import React from 'react'
import IconButton from 'material-ui/IconButton'

import css from './patient-names-list.css'

const PatientNamesList = ({ patients = [], icon, onClick }) => (
  <ul className={css.container}>
    {patients.map(patient => (
      <li key={patient.id} className={css.patient}>
        <span className={css.name}>{`${patient.first_name} ${patient.last_name}`}</span>
        <IconButton
          className={css.button}
          onClick={() => onClick(patient)}
        >
          {icon}
        </IconButton>
      </li>
    ))}
  </ul>
)

export default PatientNamesList



// WEBPACK FOOTER //
// ./src/components/PatientGroups/Edit/PatientNamesList.js